<template>
  <section v-if="!verifying" id="create-password">
    <div v-if="!createLinkSent">
      <div class="set-container">
        <SACSetPassword
          header="Create Your Password"
          infoText="Please set password to activate your account"
          buttonLabel="Set Password"
          :processing="processing"
          :createPassword="createPassword"
          :error="error"
          :welcome="true"
        />
      </div>
    </div>
    <div v-else class="pass-created">
      <div class="p-header">
        Password successfully created
      </div>
      <div class="p-body">
        Please login to your account.
      </div>
    </div>
  </section>
  <section v-else id="login-verify">
    <div class="lv-body-container">
      <div class="lv-body">
        Verifying Credentials
      </div>
      <img src="@shared/assets/img/general/loading.svg" alt="Verifying">
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import SACSetPassword from '@shared/components/sac/SACSetPassword.vue';
import { persistAlphaLoginSession } from '@shared/lib/general/alphaAuth';

export default {
  name: 'CreatePasswordView',
  metaInfo: {
    title: 'SmartAC.com | Create Password',
  },
  components: {
    SACSetPassword,
  },
  data() {
    return {
      processing: false,
      createLinkSent: false,
      verifying: true,
      error: '',
    };
  },
  async mounted() {
    this.verifying = true;
    try {
      localStorage.setItem('loginEmail', this.$route.params.email);
      const provider = await this.$store.dispatch('getUserProvider', this.$route.params.email);
      if (provider) {
        this.redirectToAuth(provider);
      } else {
        this.verifying = false;
      }
    } catch (e) {
      this.error = e.message;
    }
    if (this.$route.query.error) {
      this.error = 'Please sign up with the email to which you were sent the invitation';
    }
  },
  methods: {
    async createPassword(password) {
      try {
        this.processing = true;
        await axios({
          method: 'PUT',
          url: `${process.env.API_URL}/auth/admin/change-password`,
          data: {
            password,
            passwordToken: this.$route.params.token,
          },
        });
        const { data } = await axios({
          method: 'POST',
          url: `${process.env.API_URL}/auth/admin/signin`,
          data: {
            email: this.$route.params.email,
            password,
          },
        });
        localStorage.currentUser = JSON.stringify(data);
        persistAlphaLoginSession(data);
        await this.$store.dispatch('getCurrentAdminInfo');
        const {
          redirectUrl,
        } = localStorage;
        if (this.isManufactureAdmin) {
          this.$router.replace('/quality');
        } else if (redirectUrl) {
          this.$router.replace(redirectUrl);
          delete localStorage.redirectUrl;
        } else {
          this.$router.replace('/service');
        }
      } catch (err) {
        if (err.response) {
          const {
            data,
          } = err.response;
          if (data) {
            const {
              message,
            } = data;
            this.error = message;
          }
        } else {
          this.error = err;
        }
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">
section#create-password {
  display: grid;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
  background-color: $WHITE;

  .set-container {
    justify-content: center;
    display: grid;
    margin-top: 37px;

    .border-container {
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      margin: 24px 0;
      align-items: center;
      gap: 5px;
      color: $N40;

      .divider-line {
        height: 1px;
        background-color: $N40;
      }
    }

    .auth-container {
      display: grid;
      gap: 24px;

      .google-auth-btn {
        display: grid;
        justify-content: center;
        align-items: center;
        gap: 10px;
        grid-auto-flow: column;
        border-radius: 12px;
        background: $WHITE;
        height: 56px;
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 2px 3px 0 rgba(0, 0, 0, 0.17);
      }

      .apple-auth-btn {
        display: grid;
        justify-content: center;
        align-items: center;
        gap: 10px;
        grid-auto-flow: column;
        padding: 12px;
        border-radius: 12px;
        background: $BLACK;
        height: 56px;
        border: 1.176px solid #979797;
        box-shadow: 0 0 3.2px 0 rgba(0, 0, 0, 0.08), 0 2px 3.2px 0 rgba(0, 0, 0, 0.17);
      }
    }

    .logo-container {
      margin-top: 32px;
      display: flex;
      justify-content: center;

      .logo {
        width: 184px;
        height: 21px;

        @media (max-width: 420px) {
          width: 120px;
          height: 15px;
        }

        @media (max-width: 320px) {
          width: 100px;
          height: 12px;
        }
      }
    }
  }

  .pass-created {
    width: 400px;
    height: 200px;
    padding: 2rem;
    text-align: center;
    display: grid;
    align-items: center;
    border-radius: 12px;

    .p-header {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      color: $N80;
    }

    .p-body {
      text-align: center;
      padding: 1rem;
    }
  }
}
</style>
